import React, { useEffect, useState, useContext } from 'react';
import { PreAuthLayout } from './Features/PreAuthLayout';
import { LoadingScreen } from './Features/LoadingScreen';
import { PostAuthLayout } from './Features/PostAuthLayout';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter as Router } from 'react-router-dom';
import { UserProvider, UserContext } from './contexts/UserProvider';
import { AccountSetup } from './Features/AccountSetup';

const queryClient = new QueryClient();

// Create a theme instance.
const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    // You can customize your palette here
  },
  // ... you can also customize other aspects of the theme
});

function App() {
  const { userAuth, userData, isLoading } = useContext(UserContext);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={darkTheme}>
          <CssBaseline />
          {isLoading ?
            <LoadingScreen />
          : userAuth && userData ? 
            <Router>
              <PostAuthLayout />
            </Router>
          : userAuth ?
            <AccountSetup />
          :
            <PreAuthLayout />
          }
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
